import { render, staticRenderFns } from "./CanvasItem.vue?vue&type=template&id=4add7e3e&scoped=true"
import script from "./CanvasItem.vue?vue&type=script&lang=js"
export * from "./CanvasItem.vue?vue&type=script&lang=js"
import style0 from "./CanvasItem.vue?vue&type=style&index=0&id=4add7e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add7e3e",
  null
  
)

export default component.exports